import {
  ProofOfIdentityType,
  ResearchCategory,
  ResearchSheetType,
  Sex,
} from 'enums';

export const sexOptions = [
  {
    id: Sex.MALE,
    label: 'Muž',
  },
  {
    id: Sex.FEMALE,
    label: 'Žena',
  },
];

export const proofOfIdentityTypeOptions = [
  {
    id: ProofOfIdentityType.CAS,
    label: 'Průkaz UK',
  },
  {
    id: ProofOfIdentityType.ID_CARD,
    label: 'Občanský průkaz',
  },
  {
    id: ProofOfIdentityType.PASSPORT,
    label: 'Pas',
  },
  {
    id: ProofOfIdentityType.OTHER,
    label: 'Jiný',
  },
];

export const researchCategoryOptions = [
  {
    id: ResearchCategory.SCIENTIFIC_PUBLICATIONS,
    label: 'Vědecké (studie, monografie, studentská)',
  },
  {
    id: ResearchCategory.SCIENTIFIC_EDITIONS,
    label: 'Vědecké edice dokumentů',
  },
  {
    id: ResearchCategory.GENEALOGY,
    label: 'Genealogické účely',
  },
  {
    id: ResearchCategory.PERSONAL,
    label: 'Soukromé zájmové vzdělávání',
  },
  {
    id: ResearchCategory.JOURNALISTIC,
    label: 'Publicistické účely',
  },
  {
    id: ResearchCategory.EXPOSITION,
    label: 'Výstavní účely',
  },
  {
    id: ResearchCategory.OFFICE,
    label: 'Pro potřeby úřadů',
  },
  {
    id: ResearchCategory.CHRONICLE,
    label: 'Kronikářské',
  },
];

export const researchSheetTypeOptions = [
  {
    id: ResearchSheetType.PERSONAL,
    label: 'Soukromý',
  },
  {
    id: ResearchSheetType.CREDENTIAL,
    label: 'Služební',
  },
];
